 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"4161d0fb87e9c31bef1eda8e51edf8f11408f8b2","2":"18a7ec8850cc67b3b2c41143a2097f9754832d90","3":"framework","4":"9daaf0314c6d6f07e317e38947f76bda42b93467","5":"c5a1bc9349ded80cd9e637d5e078078fba187112","8":"component---gatsby-theme-husky-src-pages-404-tsx","9":"component---gatsby-theme-husky-src-templates-about-us-page-about-us-page-tsx","10":"component---gatsby-theme-husky-src-templates-article-page-article-page-tsx","11":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","12":"component---gatsby-theme-husky-src-templates-find-your-veet-page-find-your-veet-page-tsx","13":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","14":"component---gatsby-theme-husky-src-templates-lds-page-index-ts","15":"component---gatsby-theme-husky-src-templates-product-detail-page-product-detail-page-tsx","16":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","17":"component---gatsby-theme-husky-src-templates-search-results-page-search-results-page-tsx","18":"component---gatsby-theme-husky-src-templates-sitemap-page-sitemap-page-tsx","19":"component---gatsby-theme-husky-src-templates-tips-and-tricks-page-tips-and-tricks-page-tsx","20":"component---gatsby-theme-husky-src-templates-tips-and-tricks-videos-page-tips-and-tricks-videos-page-tsx","21":"component---gatsby-theme-husky-src-templates-tips-for-you-page-tips-for-you-page-tsx","22":"component---gatsby-theme-husky-src-templates-where-to-buy-page-where-to-buy-page-tsx","23":"components-PromoPanel","24":"components-SignUpBanner"}[chunkId]||chunkId) + "-" + {"0":"0d098664d6fadd516166","1":"df02e86c68f0dc3437fe","2":"629f06634225173698d7","3":"9e9f65e8a014192ff961","4":"0fde22c2d6d60b02972b","5":"a1c647b3086c474aa3f8","8":"3fcbe80f17c2e5530f37","9":"c46292061dd6c1c6d782","10":"c6a54b6b4665e3c968b7","11":"84f11fe77ada4d9bb59f","12":"036336c64e7e4e5d84e8","13":"5f5c4ac94ca3df7f4fc0","14":"0acc626e39cfdf2ee546","15":"523ef758e40c4effa4f6","16":"5244ceefab1544d47c2b","17":"c58335ff1e11b5c1429d","18":"1fefacb3f1ad01e02ced","19":"4f8d9bbc84534c9d3ebf","20":"cb3485d14b5d9df20361","21":"83141601307c552217c1","22":"8ea3efc9b2dba9e7604c","23":"cc3580683c5b1c448704","24":"bd1994746c4af69f22e8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"4161d0fb87e9c31bef1eda8e51edf8f11408f8b2","2":"18a7ec8850cc67b3b2c41143a2097f9754832d90","3":"framework","4":"9daaf0314c6d6f07e317e38947f76bda42b93467","5":"c5a1bc9349ded80cd9e637d5e078078fba187112","8":"component---gatsby-theme-husky-src-pages-404-tsx","9":"component---gatsby-theme-husky-src-templates-about-us-page-about-us-page-tsx","10":"component---gatsby-theme-husky-src-templates-article-page-article-page-tsx","11":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","12":"component---gatsby-theme-husky-src-templates-find-your-veet-page-find-your-veet-page-tsx","13":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","14":"component---gatsby-theme-husky-src-templates-lds-page-index-ts","15":"component---gatsby-theme-husky-src-templates-product-detail-page-product-detail-page-tsx","16":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","17":"component---gatsby-theme-husky-src-templates-search-results-page-search-results-page-tsx","18":"component---gatsby-theme-husky-src-templates-sitemap-page-sitemap-page-tsx","19":"component---gatsby-theme-husky-src-templates-tips-and-tricks-page-tips-and-tricks-page-tsx","20":"component---gatsby-theme-husky-src-templates-tips-and-tricks-videos-page-tips-and-tricks-videos-page-tsx","21":"component---gatsby-theme-husky-src-templates-tips-for-you-page-tips-for-you-page-tsx","22":"component---gatsby-theme-husky-src-templates-where-to-buy-page-where-to-buy-page-tsx","23":"components-PromoPanel","24":"components-SignUpBanner"}[chunkId]||chunkId) + "." + {"0":"dfaf6858e89965105ffb","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","8":"87e3d04de5c4dd9931de","9":"1048e889a4900f044c31","10":"0b03c1487980791206d9","11":"73c98753fac2d4816f7b","12":"de7192b93526723029db","13":"b18e740fd2cc735220b8","14":"d5e1d58186584874d743","15":"6e97f028b7d8aa27a34c","16":"122dd41d3ba1e54f1bdd","17":"21a66aaa402ae65d8f24","18":"70b6722104e9cb2056e3","19":"c539cc3f99ccf3d7dd9a","20":"f5d09ea88b0a76cf40d8","21":"870a3bd7d799be50375e","22":"6cc5900c4332b0c09a63","23":"9101055587dade7e257f","24":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
